import { useState, useRef, useEffect, useCallback } from 'react';
import _ from 'lodash';

interface BoundingBox {
  top: number;
  left: number;
  bottom: number;
  right: number;
  width: number;
  height: number;
  x: number;
  y: number;
}

export const useRect = (): [
  Partial<BoundingBox>,
  React.RefObject<HTMLElement>,
] => {
  const ref = useRef<HTMLElement>(null);
  const [bbox, setBbox] = useState<Partial<BoundingBox>>({});

  const set = _.debounce(() => {
    setBbox(ref && ref.current ? ref.current.getBoundingClientRect() : {});
  }, 60);

  const debouceSet = useCallback(() => set(), [set]);

  useEffect(() => {
    set();
    window.addEventListener('scroll', debouceSet);
    return () => window.removeEventListener('scroll', debouceSet);
  }, []);

  return [bbox, ref];
};
